import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import { isNumeric, isUuid, createCustomPropType } from '../../../../../js/app/react/validators';
import { EDIT_ACCOUNT, DELETE_ACCOUNT } from './AccountsOverviewMenuOptions';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';
import Tooltip from '../../../../CommonComponents/Tooltip';
import workflowAnalyticsEvents from '../../../AnalyticsWorkflow/AnalyticsWorkflow';
import { WORKFLOW_ID as DECUMULATION_WORKFLOW_ID } from '../../../DecumulationWorkflow/DecumulationWorkflow.constants';
import Validation from '../../../Validation/ValidationContainer';

const validateAccounts = accounts => () => {
  if (!accounts || accounts.length === 0 || !accounts.some(({ isSelected }) => isSelected)) {
    return ['Please select an account'];
  }
  return [];
};

const AccountsOverviewView = ({
  clientId,
  workflowId,
  accountsList,
  graphAccounts,
  onMenuOptionClicked,
  onAddAccount,
  onToggleIsSelected,
  name,
  accountsTitle,
  isEmptyState,
  isSingleSelection,
}) => (
  <div className="AccountsOverviewView">
    <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.Accounts`} />

    <h2 className="h2">{accountsTitle}</h2>

    <div className="adv-workflow-crud-widget">
      {isEmptyState ? (
        <div className="adv-workflow-crud-empty">
          <div className="adv-workflow-crud-empty-add">
            <button
              className="adv-workflow-crud-empty-add-button"
              type="button"
              onClick={onAddAccount(
                graphAccounts,
                workflowId,
                clientId,
                name,
                `${BACKEND_KEY}.Accounts`,
              )}
            >
              <i className="adv-workflow-crud-empty-add-button-i">+</i>
              <br />
              Add a new account
            </button>
          </div>
        </div>
      ) : (
        <div className="adv-workflow-crud-populated">
          <ul className="adv-workflow-crud-populated-ul">
            {/* eslint-disable-next-line */}
            {accountsList.map(({ id, label, value, isSelected, isLink }) => (
              <li className="adv-workflow-crud-populated-li" key={id}>
                <Tooltip
                  tag="button"
                  tooltipchildren="Select this account to fund my goal"
                  aria-label="select account"
                  aria-pressed={isSelected}
                  orientation="top"
                  className="adv-workflow-crud-populated-checkbox"
                  type="button"
                  onClick={onToggleIsSelected(
                    workflowId,
                    clientId,
                    id,
                    graphAccounts,
                    isSelected,
                    name,
                    isSingleSelection,
                  )}
                >
                  {isSelected ? (
                    <i className="adv-workflow-crud-populated-checkbox-i fa fa-check" />
                  ) : (
                    <i className="adv-workflow-crud-populated-checkbox-i-unselected fa" />
                  )}
                </Tooltip>
                <div className="adv-workflow-crud-populated-name-2">{label}</div>
                <div className="adv-workflow-crud-populated-value-2">{value}</div>
                <div className="adv-workflow-crud-populated-actions">
                  <button
                    type="button"
                    aria-label="edit account"
                    className="adv-workflow-crud-populated-action"
                    onClick={onMenuOptionClicked(
                      workflowId,
                      clientId,
                      id,
                      graphAccounts,
                      name,
                    )(EDIT_ACCOUNT)}
                  >
                    <i className="adv-workflow-crud-populated-action-i far fa-edit" />
                  </button>
                  {isLink ? (
                    <div className="adv-workflow-crud-populated-action">
                      <i className="adv-workflow-crud-populated-action-i fa fa-link" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      aria-label="delete account"
                      className="adv-workflow-crud-populated-action"
                      onClick={onMenuOptionClicked(
                        workflowId,
                        clientId,
                        id,
                        graphAccounts,
                        name,
                      )(DELETE_ACCOUNT)}
                    >
                      <i className="adv-workflow-crud-populated-action-i far fa-trash-alt" />
                    </button>
                  )}
                </div>
              </li>
            ))}
          </ul>
          <div className="adv-workflow-crud-populated-add">
            <button
              className="adv-workflow-crud-populated-add-button"
              onClick={onAddAccount(
                graphAccounts,
                workflowId,
                clientId,
                name,
                `${BACKEND_KEY}.Accounts`,
              )}
              type="button"
            >
              <i className="adv-workflow-crud-populated-add-button-i">+</i>
              Add a new account
            </button>
          </div>
        </div>
      )}
    </div>
    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      workflowId={workflowId}
      backendKey={BACKEND_KEY}
      validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'accounts_funds_completed')}
      validator={
        workflowId === DECUMULATION_WORKFLOW_ID ? validateAccounts(accountsList) : undefined
      }
      validationId={workflowId === DECUMULATION_WORKFLOW_ID ? `${BACKEND_KEY}.Accounts` : undefined}
    />
  </div>
);

AccountsOverviewView.defaultProps = {
  name: null,
};

AccountsOverviewView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  workflowId: PropTypes.string.isRequired,
  isEmptyState: PropTypes.bool.isRequired,
  accountsList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: createCustomPropType(isUuid).isRequired,
      isSelected: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  graphAccounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onMenuOptionClicked: PropTypes.func.isRequired,
  onToggleIsSelected: PropTypes.func.isRequired,
  onAddAccount: PropTypes.func.isRequired,
  name: PropTypes.string,
  accountsTitle: PropTypes.string.isRequired,
  isSingleSelection: PropTypes.bool.isRequired,
};

export default AccountsOverviewView;
